import React, { FC, useState } from 'react';
import { Prompt } from '../shared/Prompt';
import { useTranslations } from '../../hooks/useTranslationsHelper';
import { MobileDownloadIcon } from '../shared/SVG/Icons/MobileDownloadIcon';
import { NativeEventBus } from '../../native/NativeEventBus';
import { useDeviceInfo } from '../../hooks/useDeviceInfo';
import Cookies from 'js-cookie';
import './AppDownloadPrompt.scss';
import { useUserContext } from '../../providers/UserProvider';

const COOKIE_KEY = 'mobile_download_prompt_dismissed';

export const AppDownloadPrompt: FC = () => {
  const [promptAcknowledged, setPromptAcknowledged] = useState(false);
  const { t } = useTranslations();

  const { isMobileDevice, isIos } = useDeviceInfo();
  const isNativeApp = NativeEventBus.isNativeBridgeAvailable();
  const isMobile = isMobileDevice && !isNativeApp;
  const platform: 'apple' | 'android' = isIos ? 'apple' : 'android';
  const { lastLogins } = useUserContext();

  const handlePromptClose = (): void => {
    setPromptAcknowledged(true);
    saveDismissalCookie();
  };

  const handlePromptDownload = (): void => {
    if (platform === 'android') {
      window.open('https://play.google.com/store/apps/details?id=uk.co.betzone.mobile', '_blank');
    } else if (platform === 'apple') {
      window.open('https://apps.apple.com/gb/app/betzone-sportsbook-casino/id1570404946', '_blank');
    }

    setPromptAcknowledged(true);
    saveDismissalCookie();
  };

  const shouldShowPrompt = (): boolean => {
    return !Cookies.get(COOKIE_KEY);
  };

  const saveDismissalCookie = (): void => {
    Cookies.set(COOKIE_KEY, 'true', { expires: 7 });
  };

  const hasMultipleLogins = (lastLogins?.length ?? 0) > 1;
  const showPrompt = !promptAcknowledged && isMobile && shouldShowPrompt() && hasMultipleLogins;

  return (
    <>
      <div className="questionnaires-list">
        <Prompt
          PrimaryButton={{ text: t('mobile-web-browser.primaryCTA'), onClick: handlePromptDownload }}
          SecondaryButton={{ text: t('mobile-web-browser.secondaryCTA'), onClick: handlePromptClose }}
          show={showPrompt}
          onClose={handlePromptClose}
          className="mobile-download-prompt"
        >
          <div className="prompt__content">
            <div className="prompt__icon">
              <MobileDownloadIcon />
            </div>
            <div className="prompt__text">{t('mobile-web-browser-full-text')}</div>
          </div>
        </Prompt>
      </div>
    </>
  );
};
